// extracted by mini-css-extract-plugin
export default {"Semilleros":"semilleros_Semilleros__TevsD"};